import { useState } from 'react';
import OrdenesList from './List.jsx';
import OrdenCompraForm from './Form.jsx';
import OrdenCompraDetail from './Detail.jsx';

export default function OrdenesPage() {
  const [view, setView] = useState('list');
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = () => setRefreshKey((key) => key + 1);

  const handleSaved = () => {
    setView('list');
    setSelectedId(null);
    setSelectedData(null);
    refresh();
  };

  const handleBack = () => {
    setView('list');
    setSelectedId(null);
    setSelectedData(null);
    refresh();
  };

  if (view === 'create') {
    return <OrdenCompraForm onCancel={handleBack} onSaved={handleSaved} />;
  }

  if (view === 'edit') {
    return <OrdenCompraForm initialData={selectedData} onCancel={handleBack} onSaved={handleSaved} />;
  }

  if (view === 'detail' && selectedId) {
    return (
      <OrdenCompraDetail
        ordenId={selectedId}
        onBack={handleBack}
        onEdit={(orden) => {
          setSelectedData(orden);
          setSelectedId(orden?.id ?? selectedId);
          setView('edit');
        }}
      />
    );
  }

  return (
    <OrdenesList
      refreshKey={refreshKey}
      onCreate={() => {
        setSelectedId(null);
        setSelectedData(null);
        setView('create');
      }}
      onSelect={(id) => {
        setSelectedId(id);
        setSelectedData(null);
        setView('detail');
      }}
    />
  );
}
